import BookingDetailsContent from './BookingDetailsContent';

const BikeTravelBookingDetails = () => <BookingDetailsContent />;

export default BikeTravelBookingDetails;
